export enum EnumStorageKeys {
  APP_LANGUAGE = 'unicoSkill@language',
  SESSION_ID = 'unicoSkill@sessionId'
}
